import { render } from "./LibraryPage.vue?vue&type=template&id=af2623da"
import script from "./LibraryPage.vue?vue&type=script&lang=js"
export * from "./LibraryPage.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/gift/data/www/giftxyz.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__